// extracted by mini-css-extract-plugin
export default {"symbolLogoWrapper":"CompanyLogoCheckmark_symbolLogoWrapper__zNn4u","icon":"CompanyLogoCheckmark_icon__GOEd2","logo":"CompanyLogoCheckmark_logo__DjKFM"};